<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Live Campaigns</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <DataGrid :context="'LiveCampaignsList'" 
        ref="campaignsList"
        :columnDefs="campaignsColumnDefs"
        :rowData="campaignsRecords"
        :dataSource="campaignsDataSource"
        @goToLiveSDDashboard="goToLiveSDDashboard"
        @goToLiveSalesDeveloperDefaultViews="goToLiveSalesDeveloperDefaultViews"

        
      >
      </DataGrid>
    </vx-card>
    <vs-popup
    title="Set Default View"
    :active.sync="showHideEditSDDefaultViewPopup"
  >


    <vs-row vs-w="12">
     

       


                <!-- <v-select style="width:100%" v-model="selected_view_for_sd" label="name" :options="sd_view_options"
                name="sd_view" /> -->
         

                 <template v-for="views in sd_view_options">

                  <vs-row vs-w="12" class="p-2">

                  <vs-radio 
                  v-model="selected_default_view"
                  :vs-value="views"
                  class="mr-4"
                  vs-name="selected_default_view"
                  >{{ views.name }}
                </vs-radio>
                  </vs-row>


                  <!-- <input
                  @click="check($event)"
                    type="checkbox"
                    :value="client_user.uuid"
                    :checked="selected_users_for_edit.includes(client_user.uuid)?'checked':null"
                  />
                  <h6 class="p-1">{{ client_user.full_name }}</h6> -->

                 </template>
                 



              
                

                

                <vs-button v-if="sd_view_options.length != 0"
                class="mt-5"
                @click.prevent="updateSalesDeveloperDefaultViewAction"
                >Submit</vs-button
              >

             

      
    
    </vs-row>
  </vs-popup>
  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    selected_campaign_id : null,
    selected_default_view : null,
    user_id : null,
    sd_view_options : [],
    showHideEditSDDefaultViewPopup : false,
    sales_developer_id : null,
    abilities: null,
    campaignsColumnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 80
      },
      {
        headerName: "Campaign",
        field: "campaign_name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Campaign Code",
        field: "campaign_code",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "Start Date",
        field: "start_date",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
        headerName: "End Date",
        field: "end_date",
                flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      }
    ],
    campaignsRecords: [],
    selected_campaign: null
  }),
  components: {
    "v-select": vSelect,
    DataGrid
  },
  watch: {},
  methods: {
    getSDViewLists() {
      let self = this
      let data = {}
      data.campaign_id = this.selected_campaign_id
      data.sales_developer_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getSDViewLists", data)
        .then(res => {
          if (res) {
            self.sd_view_options = res.data;


            self.sd_view_options.forEach(function(e){
              if (e.is_default_view){
                self.selected_default_view = e
              }
            })

            console.log(self.sd_view_options)

            self.showHideEditSDDefaultViewPopup = true

          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateSalesDeveloperDefaultViewAction(){
      console.log(this.selected_default_view)


      let self = this

      let data = {}
      data.campaign_id = self.selected_campaign_id
      data.sales_developer_id = self.user_id;
      if(this.selected_default_view){
        data.selected_default_view_id = this.selected_default_view.id
      }

      if (data.selected_default_view_id){


      self.$store
      .dispatch(
        'campaignsManagement/updateSalesDeveloperDefaultViewAction',
        data
      )
      .then(res => {
        if (res) {
          if (res.data.status == 'success') {
            location.reload();

          }
        }
      })
      .catch(err => {
        console.log(err)
      })



      }

    





    },
    goToLiveSalesDeveloperDefaultViews(data){
      this.selected_campaign_id = data.campaign_id
      this.getSDViewLists()
      console.log(data)
    },
    sdDashboard() {
      this.$router.replace("/sales-developer-dashboard/view/" + this.selected_campaign.campaign_id + '/' + btoa(this.selected_campaign.campaign_name));
    //  alert("got to")
    },
    goToLiveSDDashboard(value) {
      this.selected_campaign = value;
      this.selected_campaign_id = value.campaign_id;
      this.sdDashboard();
    },

    getcampaignDataSource() {
      var self = this;

      this.campaignsDataSource = {
        getRows(params) {
          params.request.sales_developer_id = self.sales_developer_id
          self.$store
            .dispatch(
              "campaignsManagement/getSalesDeveloperLiveCampaignsForGrid",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;




              if (response_data.length != 0) {
                self.$refs.campaignsList.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.campaignsList.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }


            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getcampaignDataSource();
  },
  mounted() {},
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    self.sales_developer_id = userInfo["uid"];
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
